// https://www.freecodecamp.org/news/how-to-add-localization-to-your-react-app/
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  fallbackLng: 'it',
  lng: 'it',
  resources: {
    it: {
      translations: require('./locales/it/translations.json'),
    },
    en: {
      translations: require('./locales/en/translations.json'),
    }
  },
  interpolation: {
    escapeValue: false,
  },
  ns: ['translations'],
  defaultNS: 'translations',
});

i18n.languages = ['it', 'en'];

export default i18n;
